import { z } from 'zod';

/** The tabs of the Files app; "recent" is the default (no `tab` in the address). */
export const FILES_TABS = ['recent', 'organisation', 'shared', 'search'] as const;
export type FilesTab = (typeof FILES_TABS)[number];

export const isFilesTab = (value: string): value is FilesTab =>
  (FILES_TABS as readonly string[]).includes(value);

/**
 * Search params of /o/$orgId/files (GED-FE-09): the open tab, kept in the address so a view can be
 * shared and survives a reload. An invalid value is simply dropped.
 */
export const FilesSearchSchema = z.object({
  tab: z.enum(['organisation', 'shared', 'search']).optional().catch(undefined),
});
export type FilesSearch = z.infer<typeof FilesSearchSchema>;
